module.exports = __webpack_public_path__ + "static/media/konsep_2.79bdcf25.jpg";